import { render, staticRenderFns } from "./projectinfoselector.vue?vue&type=template&id=55cd63b4"
import script from "./projectinfoselector.vue?vue&type=script&lang=js"
export * from "./projectinfoselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports